import env from './env/env.spell';

export default env;
